import { motion } from "framer-motion";
import energyImg from "./assets/energy.webp";

const HeroSection = () => {
  return (
    <section className="w-full bg-[#10101E] py-20 px-4 sm:px-6">
      <div className="w-full max-w-[1312px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
        {/* LEFT CONTENT */}
        <motion.div
          className="w-full lg:w-[60%]"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          <p className="text-[#FFFFFF] font-semibold text-sm mb-3 uppercase tracking-wider">
            Energy
          </p>
          <h1 className="text-[#FFFFFF] text-[40px] md:text-[48px] leading-[52px] md:leading-[58px] font-extrabold mb-[24px]">
            Empowering the Future
            <br className="hidden lg:block" />
            of Energy with IoT
          </h1>
          <p className="text-[#FFFFFF] text-[16px] md:text-[18px] leading-[28px] md:leading-[30px] max-w-[600px]">
            Unlock smarter, cleaner and more efficient energy systems through
            intelligent IoT technologies.
          </p>
        </motion.div>

        {/* RIGHT IMAGE */}
        <motion.div
          className="w-full lg:w-[40%] flex justify-center lg:justify-end"
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          <img
            src={energyImg}
            alt="Energy IoT Illustration"
            className="w-[380px] sm:w-[460px] md:w-[520px] lg:w-full max-w-[600px] h-auto object-contain"
          />
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
